var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v("لیست تحویل ها")]),_c('v-card-text',[_c('m-datatable',{ref:"datatable",attrs:{"headers":_vm.headers,"apiUrl":_vm.url,"filters":_vm.filters},on:{"update:filters":function($event){_vm.filters=$event}},scopedSlots:_vm._u([{key:"item.detail",fn:function(ref){
var item = ref.item;
return [_c('detail-link',{attrs:{"to":_vm.to(item)}})]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }